import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export function initSingleComuniBlocks(root = document) {
  const sliders = root.querySelectorAll('.js-comuni-gallery-swiper');
  const cosaFareSliders = root.querySelectorAll('.js-comuni-cosa-fare-swiper');

  sliders.forEach((sliderEl) => {
    if (sliderEl.swiper) {
      return;
    }

    const slides = sliderEl.querySelectorAll('.swiper-slide');

    if (slides.length <= 1) {
      const paginationEl = sliderEl.querySelector('.swiper-pagination');
      if (paginationEl) {
        paginationEl.style.display = 'none';
      }
      return;
    }

    new Swiper(sliderEl, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      grabCursor: true,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });

  const relatedCardSwipersConfig = {
    slidesPerView: 1.1,
    spaceBetween: 24,
    grabCursor: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  };

  cosaFareSliders.forEach((sliderEl) => {
    if (sliderEl.swiper) {
      return;
    }
    new Swiper(sliderEl, relatedCardSwipersConfig);
  });

  const esperienzaSliders = root.querySelectorAll('.js-comuni-esperienze-swiper');
  esperienzaSliders.forEach((sliderEl) => {
    if (sliderEl.swiper) {
      return;
    }
    new Swiper(sliderEl, relatedCardSwipersConfig);
  });

  const partnerSections = root.querySelectorAll('.js-comuni-partner-section');
  partnerSections.forEach((sectionEl) => {
    if (sectionEl.dataset.ajaxBound === '1') {
      return;
    }

    sectionEl.dataset.ajaxBound = '1';

    sectionEl.addEventListener('click', async (event) => {
      const linkEl = event.target.closest('.js-inline-pagination-link');
      if (!linkEl || !sectionEl.contains(linkEl)) {
        return;
      }

      const page = Number.parseInt(linkEl.dataset.page || '1', 10);
      const comuneId = Number.parseInt(sectionEl.dataset.comuneId || '0', 10);
      if (!comuneId || !page) {
        return;
      }

      event.preventDefault();

      const resultsEl = sectionEl.querySelector('.js-comuni-partner-results');
      if (!resultsEl) {
        return;
      }

      sectionEl.classList.add('is-loading');

      try {
        const payload = new URLSearchParams();
        payload.set('action', 'mapo_load_comuni_partner_page');
        payload.set('nonce', mapoScripts?.ajaxNonce || '');
        payload.set('comune_id', String(comuneId));
        payload.set('page', String(page));

        const response = await fetch(mapoScripts.ajaxUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: payload.toString(),
        });

        const data = await response.json();
        if (!data?.success || !data?.data?.html) {
          return;
        }

        resultsEl.outerHTML = data.data.html;

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('partner_page', String(page));
        currentUrl.hash = 'partner';
        window.history.replaceState({}, '', currentUrl.toString());
      } catch (error) {
        // Keep native links as fallback when ajax fails.
      } finally {
        sectionEl.classList.remove('is-loading');
      }
    });
  });
}

